import { render, staticRenderFns } from "./GroupCSVWidget.vue?vue&type=template&id=37fc475f&scoped=true"
import script from "./GroupCSVWidget.vue?vue&type=script&lang=js"
export * from "./GroupCSVWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc475f",
  null
  
)

export default component.exports